/**
 * Created by ivan on 25.05.18.
 */

const CandleCellView = BaseCellView.extend({ 
    ctor: function (candleCell) {
        this._super();

        this.setContentSize(cleverapps.styles.BaseCellView.CELL_SIZE_PX, cleverapps.styles.BaseCellView.CELL_SIZE_PX);
        this.setAnchorPoint(0.5, 0.5);

        const animation = new cleverapps.Spine(bundles.candle.jsons.candle_json);
        animation.setPosition(this.width / 2, this.height / 2);
        if (candleCell.state === CandleCell.STATE_ON || candleCell.isForGoal) {
            animation.setAnimation(0, "burn", true);
        } else {
            animation.setAnimation(0, "put_out", false);
        }
        this.addChild(animation);
        this.animation = animation;

        this.initialize(candleCell);
    },

    initialize: function (candleCell) {
        this._super(candleCell);

        candleCell.onChangeStateListener = this.createListener(this.update.bind(this));
    },

    update: function () {
        if (this.cell.state === CandleCell.STATE_ON) {
            this.animation.setAnimation(0, "lights_up", false);
            this.animation.setCompleteListener(() => {
                this.animation.setAnimation(0, "burn", true);
            });
            cleverapps.effects.fire("candle.on");
        } else {
            this.animation.setAnimation(0, "put_out", false);
            this.animation.setCompleteListener();
            cleverapps.effects.fire("candle.off");
        }
    }
});